export const coinIconUrls = {
  bitcoin: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  ethereum: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  binancecoin: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  solana: 'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  'pax-gold': 'https://assets.coingecko.com/coins/images/9519/small/paxgold.png',
  ripple: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png',
  dogecoin: 'https://assets.coingecko.com/coins/images/5/small/dogecoin.png',
  cardano: 'https://assets.coingecko.com/coins/images/975/small/cardano.png',
  'avalanche-2': 'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
};

export const stockLogoUrls = {
  NVDA: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/nvidia.svg',
  MSTR: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/microstrategy.svg',
  COIN: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/coinbase.svg',
  QQQ: 'https://companiesmarketcap.com/img/company-logos/64/QQQ.png',
  TSLA: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/tesla.svg',
  AAPL: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/apple.svg',
};

export const fallbackHeatmapData = [
  { id: 'bitcoin', symbol: 'btc', name: 'Bitcoin', market_cap: 1200000000000, price_change_percentage_24h: -0.5, image: coinIconUrls.bitcoin },
  { id: 'ethereum', symbol: 'eth', name: 'Ethereum', market_cap: 420000000000, price_change_percentage_24h: -1.0, image: coinIconUrls.ethereum },
  { id: 'solana', symbol: 'sol', name: 'Solana', market_cap: 90000000000, price_change_percentage_24h: -1.2, image: coinIconUrls.solana },
  { id: 'binancecoin', symbol: 'bnb', name: 'BNB', market_cap: 85000000000, price_change_percentage_24h: 1.2, image: coinIconUrls.binancecoin },
  { id: 'ripple', symbol: 'xrp', name: 'XRP', market_cap: 137000000000, price_change_percentage_24h: -1.5, image: coinIconUrls.ripple },
  { id: 'dogecoin', symbol: 'doge', name: 'Dogecoin', market_cap: 33000000000, price_change_percentage_24h: 4.2, image: coinIconUrls.dogecoin },
  { id: 'cardano', symbol: 'ada', name: 'Cardano', market_cap: 28000000000, price_change_percentage_24h: -0.6, image: coinIconUrls.cardano },
  { id: 'avalanche-2', symbol: 'avax', name: 'Avalanche', market_cap: 10000000000, price_change_percentage_24h: 1.8, image: coinIconUrls['avalanche-2'] },
  { id: 'pax-gold', symbol: 'paxg', name: 'PAX Gold', market_cap: 620000000, price_change_percentage_24h: 0.3, image: coinIconUrls['pax-gold'] },
];
